// Africa country list with codes for selects.
export const AFRICA_COUNTRIES = [
  "Algeria","Angola","Benin","Botswana","Burkina Faso","Burundi","Cabo Verde","Cameroon",
  "Central African Republic","Chad","Comoros","Côte d'Ivoire","Democratic Republic of the Congo",
  "Djibouti","Egypt","Equatorial Guinea","Eritrea","Eswatini","Ethiopia","Gabon","Gambia",
  "Ghana","Guinea","Guinea-Bissau","Kenya","Lesotho","Liberia","Libya","Madagascar","Malawi",
  "Mali","Mauritania","Mauritius","Morocco","Mozambique","Namibia","Niger","Nigeria",
  "Republic of the Congo","Rwanda","São Tomé and Príncipe","Senegal","Seychelles",
  "Sierra Leone","Somalia","South Africa","South Sudan","Sudan","Tanzania","Togo","Tunisia",
  "Uganda","Zambia","Zimbabwe",
];

export const SECTORS = [
  "Agriculture & Agribusiness","Banking & Financial Services","Consumer Goods (FMCG)",
  "Education","Energy & Power","Fintech","Healthcare & Pharma","Hospitality & Tourism",
  "ICT & Telecom","Infrastructure & Construction","Logistics & Transportation","Manufacturing",
  "Media & Entertainment","Mining & Metals","Oil & Gas","Real Estate","Renewable Energy",
  "Retail & E-commerce","Technology & SaaS","Water & Sanitation",
];

export const HORIZONS = ["1–3 Years", "3–5 Years", "5–10 Years", "10+ Years"];

export const OBJECTIVES = [
  "Market Entry","Geographic Expansion","Strategic Partnership","Joint Venture",
  "Acquisition Screening","New Business Launch","Trade Expansion","Capital Deployment",
];

export const CURRENCIES = ["USD", "EUR", "GBP", "XOF", "NGN", "ZAR", "KES", "INR"];

export const RISK_PROFILES = ["Conservative", "Balanced", "Growth", "Opportunistic"];
